import { render, staticRenderFns } from "./UpdateOrgDetails.vue?vue&type=template&id=00e4ca8b&scoped=true"
import script from "./UpdateOrgDetails.vue?vue&type=script&lang=js"
export * from "./UpdateOrgDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00e4ca8b",
  null
  
)

export default component.exports